import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

export interface DocumentPreviewProperties {
	property: string;
	value: string;
}

export interface DocumentPreviewData {
	url: string;
	properties: DocumentPreviewProperties[];
}

@Component({
	selector: 'app-document-preview',
	templateUrl: './document-preview.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [ComponentsModule],
})
export class DocumentPreviewComponent {
	data: DocumentPreviewData = inject(DRAWER_DATA);
}
